module.exports = __webpack_public_path__ + "assets/images/forestlawn-flowers.bf476d68.png";


//////////////////
// WEBPACK FOOTER
// ./src/reactModules/pages/Person/components/FlowersCta/assets/forestlawn-flowers.png
// module id = 1690
// module chunks = 0